import { httpClient } from 'angieslist-app-platform';

const attachReview = (serviceProviderId, showcaseId, reviewId) =>
  httpClient.post(
    `/gateway/office-home/v1/service_provider/${serviceProviderId}/showcase/${showcaseId}/review`,
    {
      headers: {
        'X-ANGI-CallerType': 'ServiceProvider',
        'X-ANGI-CallerId': serviceProviderId,
      },
      body: { reviewId },
    },
  );

const getCategories = (serviceProviderId, searchText, limit) =>
  httpClient.get(`/gateway/service-provider/v1/categories?query=${searchText}&size=${limit}`, {
    headers: {
      'X-ANGI-CallerId': serviceProviderId,
    },
  });

const getShowcase = (serviceProviderId, showcaseId) =>
  httpClient.get(`/gateway/office-home/v1/service_provider/${serviceProviderId}/showcase/${showcaseId}`, {
    headers: {
      'X-ANGI-CallerId': serviceProviderId,
    },
  });

const saveShowcase = showcaseSubmission =>
  httpClient.post(
    `/gateway/office-home/v1/service_provider/${showcaseSubmission.serviceProviderId}/showcase`,
    {
      headers: {
        'X-ANGI-CallerId': showcaseSubmission.serviceProviderId,
      },
      body: {
        ...showcaseSubmission,
      },
    },
  );

const saveMedia = async (file, serviceProviderId, showcaseId, mediaCount, mediaIndex) => ({
  filename: file.name,
  response: await httpClient.post(
    `/gateway/office-home/v2/service_provider/${serviceProviderId}/showcase/${showcaseId}/media`,
    {
      headers: {
        'X-ANGI-CallerType': 'ServiceProvider',
        'X-ANGI-CallerId': serviceProviderId,
      },
      type: 'multipart',
      body: [
        { name: 'media', data: file, type: 'binary' },
        { name: 'metadata', data: { mediaCount, mediaIndex }, type: 'json' },
      ],
    },
  ),
});

const saveMediaOrder = (mediaIds, serviceProviderId, showcaseId) =>
  httpClient.post(
    `
    /gateway/office-home/v1/service_provider/${serviceProviderId}/showcase/${showcaseId}/media/order`,
    {
      headers: {
        'X-ANGI-CallerId': serviceProviderId,
      },
      body: {
        mediaIds,
      },
    },
  );

const saveShowcaseOrder = (showcaseIds, serviceProviderId) =>
  httpClient.post(
    `
    /gateway/office-home/v1/service_provider/${serviceProviderId}/showcase/order`,
    {
      headers: {
        'X-ANGI-CallerId': serviceProviderId,
      },
      body: {
        showcaseIds,
      },
    },
  );

const publishShowcase = (serviceProviderId, showcaseId) =>
  httpClient.post(
    `/gateway/office-home/v1/service_provider/${serviceProviderId}/showcase/${showcaseId}/publish`,
    {
      headers: {
        'X-ANGI-CallerId': serviceProviderId,
      },
      body: {},
    },
  );

const deleteMedia = (mediaIds, serviceProviderId, showcaseId) =>
  httpClient.post(
    `/gateway/office-home/v1/service_provider/${serviceProviderId}/showcase/${showcaseId}/media/delete`,
    {
      headers: {
        'X-ANGI-CallerType': 'ServiceProvider',
        'X-ANGI-CallerId': serviceProviderId,
      },
      body: {
        mediaIds,
      },
    },
  );

const updateShowcaseMedia = (description, serviceProviderId, showcaseId, mediaId, file) =>
  httpClient.put(
    `/gateway/office-home/v1/service_provider/${serviceProviderId}/showcase/${showcaseId}/media/${mediaId}`,
    {
      headers: {
        'X-ANGI-CallerType': 'ServiceProvider',
        'X-ANGI-CallerId': serviceProviderId,
      },
      type: 'multipart',
      body: [
        { name: 'media', data: file, type: 'binary' },
        { name: 'metadata', data: { description }, type: 'json' },
      ],
    },
  );

const addImageFromGallery = (serviceProviderId, imageIds, showcaseId) =>
  httpClient.post(
    `/gateway/office-home/v1/service_provider/${serviceProviderId}/showcase/${showcaseId}/media-from-image-gallery`,
    {
      headers: {
        'X-ANGI-CallerType': 'ServiceProvider',
        'X-ANGI-CallerId': serviceProviderId,
      },
      body: {
        imageIds,
      },
    },
  );

const getReviews = (request) => {
  const {
    serviceProviderId, limit, offset, memberName,
  } = request;
  return httpClient.get(
    `/gateway/office-home/v1/service_providers/${serviceProviderId}/reviews/byMember`,
    {
      params: memberName ? {
        limit,
        offset,
        memberName,
      } : {
        limit,
        offset,
      },
      headers: {
        'X-ANGI-CallerType': 'ServiceProvider',
        'X-ANGI-CallerId': +serviceProviderId,
      },
    },
  );
};

export default {
  attachReview,
  getCategories,
  getShowcase,
  saveShowcase,
  saveMedia,
  saveMediaOrder,
  saveShowcaseOrder,
  publishShowcase,
  deleteMedia,
  addImageFromGallery,
  updateShowcaseMedia,
  getReviews,
};



// WEBPACK FOOTER //
// ./src/modules/showcase/common/showcaseService.js